// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml = require("rescript/lib/js/caml.js");
var React = require("react");
var IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
var V4 = require("uuid/v4");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Belt_SortArray = require("rescript/lib/js/belt_SortArray.js");
var SystemMessages = require("../../reason/systemMessages/SystemMessages.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var NotificationSettingsBuyerNeeds = require("./NotificationSettingsBuyerNeeds.bs.js");
var NotificationSettingsComponents = require("./NotificationSettingsComponents.bs.js");
var NotificationSettingsRentalNeeds = require("./NotificationSettingsRentalNeeds.bs.js");
var NotificationSettings_areas_graphql = require("../../__generated__/NotificationSettings_areas_graphql.bs.js");
var NotificationSettingsRentalProperties = require("./NotificationSettingsRentalProperties.bs.js");
var NotificationSettings_chapter_graphql = require("../../__generated__/NotificationSettings_chapter_graphql.bs.js");
var NotificationSettingsBroadcastMessages = require("./NotificationSettingsBroadcastMessages.bs.js");
var NotificationSettingsForSaleProperties = require("./NotificationSettingsForSaleProperties.bs.js");
var NotificationSettings_userNotificationSettings_graphql = require("../../__generated__/NotificationSettings_userNotificationSettings_graphql.bs.js");

var convertFragment = NotificationSettings_userNotificationSettings_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettings_userNotificationSettings_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettings_userNotificationSettings_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationSettings_userNotificationSettings_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettings_userNotificationSettings_graphql.node, convertFragment, fRef);
}

var UserNotificationSettingsFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var areaTypeV5_decode = NotificationSettings_areas_graphql.Utils.areaTypeV5_decode;

var convertFragment$1 = NotificationSettings_areas_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettings_areas_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettings_areas_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(fRef) : undefined, NotificationSettings_areas_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettings_areas_graphql.node, convertFragment$1, fRef);
}

var AreasFragment_areaTypeV5_fromString = NotificationSettings_areas_graphql.Utils.areaTypeV5_fromString;

var AreasFragment = {
  areaTypeV5_decode: areaTypeV5_decode,
  areaTypeV5_fromString: AreasFragment_areaTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function mapCensusPlaceTypeToCityTypeOpt(x) {
  if (x === "CENSUS_PLACE") {
    return "CITY";
  } else {
    return x;
  }
}

function NotificationSettings$ExpandedAreas(props) {
  var style = props.style;
  var areas = use$1(props.areas);
  var areaTypesOrder = [
    "BLOCK_GROUP",
    "NEIGHBORHOOD",
    "SCHOOL_DISTRICT",
    "SCHOOL",
    "TOWNSHIP",
    "ZIP_CODE",
    "CITY",
    "COUNTY",
    "STATE"
  ];
  var groupedByType = Core__Array.reduce(areas, {}, (function (acc, area) {
          var areaType = mapCensusPlaceTypeToCityTypeOpt(areaTypeV5_decode(area.type_));
          if (areaType === undefined) {
            return acc;
          }
          var current = Core__Option.getOr(acc[areaType], []);
          current.push({
                id: area.id,
                label: area.label,
                type_: areaType
              });
          var current$1 = Belt_SortArray.stableSortBy(current, (function (a, b) {
                  return Caml.string_compare(a.label, b.label) | 0;
                }));
          acc[areaType] = current$1;
          return acc;
        }));
  return JsxRuntime.jsx("div", {
              children: areaTypesOrder.map(function (areaType) {
                    var areas = groupedByType[areaType];
                    if (areas !== undefined) {
                      return JsxRuntime.jsx(NotificationSettingsComponents.AreaTypesList.make, {
                                  areas: areas,
                                  areaType: areaType,
                                  style: style
                                });
                    } else {
                      return null;
                    }
                  })
            });
}

var ExpandedAreas = {
  AreasFragment: AreasFragment,
  mapCensusPlaceTypeToCityTypeOpt: mapCensusPlaceTypeToCityTypeOpt,
  make: NotificationSettings$ExpandedAreas
};

var convertFragment$2 = NotificationSettings_chapter_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationSettings_chapter_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationSettings_chapter_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NotificationSettings_chapter_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(NotificationSettings_chapter_graphql.node, convertFragment$2, fRef);
}

var ChapterFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function NotificationSettings(props) {
  var userNotificationSettings = use(props.userNotificationSettings);
  var chapter = use$2(props.chapter);
  var match = React.useState(function () {
        return false;
      });
  var setIsExpanded = match[1];
  var isExpanded = match[0];
  var match$1 = SystemMessages.useSystemMessages();
  var addMessage = match$1.addMessage;
  var handleFailure = function () {
    addMessage(SystemMessages.Message.make(V4(), "error", "There was an error updating your preferences", 5000, undefined, undefined));
  };
  var handleSuccess = function () {
    addMessage(SystemMessages.Message.make(V4(), "info", "Updated notification settings", 5000, undefined, undefined));
  };
  var match$2 = chapter.notificationPreferences;
  var chapterDefaultAreas;
  if (match$2 !== undefined) {
    var defaultPropertyNotificationAreas = match$2.defaultPropertyNotificationAreas;
    chapterDefaultAreas = defaultPropertyNotificationAreas !== undefined ? defaultPropertyNotificationAreas : undefined;
  } else {
    chapterDefaultAreas = undefined;
  }
  var numberOfAreas = Core__Option.getOr(chapterDefaultAreas, []).length;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("p", {
                                    children: "Manage the emails you receive from Top Agent Network."
                                  }),
                              JsxRuntime.jsx("p", {
                                    children: "By default, you receive all broadcasts in your chapter area(s). Customize your filters if you wish to get emails from outside your chapter area(s) or to tailor what you receive by location, price and more."
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(ButtonsV5.LinkButton.make, {
                                            onClick: (function (param) {
                                                setIsExpanded(function (prev) {
                                                      return !prev;
                                                    });
                                              }),
                                            size: "small",
                                            className: "hover:underline justify-normal",
                                            ariaExpanded: isExpanded,
                                            children: Caml_option.some(JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsx("span", {
                                                              children: JsxRuntime.jsx(IconV5.make, {
                                                                    icon: isExpanded ? "arrow-up" : "arrow-down",
                                                                    size: 14
                                                                  }),
                                                              "aria-hidden": true
                                                            }),
                                                        JsxRuntime.jsx("span", {
                                                              children: isExpanded ? "Hide " + Core__Option.getOr(chapter.displayName, "") + " chapter areas (" + numberOfAreas.toString() + ")" : "Show " + Core__Option.getOr(chapter.displayName, "") + " chapter areas (" + numberOfAreas.toString() + ")"
                                                            })
                                                      ],
                                                      className: "flex flex-row gap-2 items-center text-base text-gray-600"
                                                    }))
                                          }),
                                      isExpanded && chapterDefaultAreas !== undefined ? JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx(NotificationSettings$ExpandedAreas, {
                                                    areas: chapterDefaultAreas.map(function (v) {
                                                          return v.fragmentRefs;
                                                        })
                                                  }),
                                              className: "mt-2"
                                            }) : null
                                    ],
                                    className: "flex flex-col gap-1"
                                  })
                            ],
                            className: "space-y-4 flex flex-col"
                          }),
                      className: "max-w-2xl"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(NotificationSettingsForSaleProperties.make, {
                            notificationSetting: userNotificationSettings.fragmentRefs,
                            onSuccess: handleSuccess,
                            onFailed: handleFailure,
                            chapter: chapter.fragmentRefs
                          })
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(NotificationSettingsRentalProperties.make, {
                            notificationSetting: userNotificationSettings.fragmentRefs,
                            onSuccess: handleSuccess,
                            onFailed: handleFailure,
                            chapter: chapter.fragmentRefs
                          })
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(NotificationSettingsBuyerNeeds.make, {
                            notificationSetting: userNotificationSettings.fragmentRefs,
                            onSuccess: handleSuccess,
                            onFailed: handleFailure,
                            chapter: chapter.fragmentRefs
                          })
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(NotificationSettingsRentalNeeds.make, {
                            notificationSetting: userNotificationSettings.fragmentRefs,
                            onSuccess: handleSuccess,
                            onFailed: handleFailure,
                            chapter: chapter.fragmentRefs
                          })
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(NotificationSettingsBroadcastMessages.make, {
                            notificationSetting: userNotificationSettings.fragmentRefs,
                            onSuccess: handleSuccess,
                            onFailed: handleFailure
                          })
                    })
              ],
              className: "flex flex-col space-y-2"
            });
}

var make = NotificationSettings;

exports.UserNotificationSettingsFragment = UserNotificationSettingsFragment;
exports.ExpandedAreas = ExpandedAreas;
exports.ChapterFragment = ChapterFragment;
exports.make = make;
/* react Not a pure module */
